import styled from "@emotion/styled";
import { Centered, Container } from "@snapchat/snap-design-system";

export const StyledContainer = styled(Container)`
    margin-top: 72px;
    padding: 25px;
`;

export const StyledCentered = styled(Centered)`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
